import $ from 'jquery';
import 'bootstrap';
import 'ion-rangeslider';
import './utils/sliders';
import './utils/callback';
import './utils/products';
import './utils/product-modification';
import './utils/cart';
import './utils/luneva';
import './utils/luneva-map';
import './utils/registration';
import Vue from 'vue';
import Inputmask from "inputmask";
import { productApp } from "../../../../../../plugins/infocity/shop/assets/app";
import Alert from "./ui/Alert";
import './utils/product-variants';
import { Modal, Popover } from 'bootstrap';
import SimpleBar from "simplebar";

// эта настройка нужна для корректной работы $ вне этого приложения
window.$ = $;
window.jQuery = $;
window.Modal = Modal;
window.Popover = Popover;

export const EventBus = new Vue();


require('@fancyapps/fancybox');

$(function () {
    const mask = new Inputmask('+7 (999) 999-99-99');
    mask.mask(document.querySelectorAll('.maskedinput-phone'));

    if (document.querySelector('.app-color-filter-block') != null) {
        new SimpleBar(document.querySelector('.app-color-filter-block'));
    }

    // fancybox
    $('[data-fancybox="gallery"]').fancybox();

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl, {
        html: true
    }))

    let url = window.location.pathname;
    url = url.split('/');
    url = '/' + url[1];
    $('.nav-item a[href="' + url + '"]').addClass('active');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('.scrollup').removeClass('d-none');
        } else {
            $('.scrollup').addClass('d-none');
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    EventBus.$on('onCartShowModificationsList', () => {
        Alert.error('Пожалуйста, выберите размер');
    });

    productApp();
});

$(".admissionOpenModal").click(function () {
    let modificationId = $(this).data('modification-id');
    let modificationName = $(this).data('modification-name');
    let modificationCode = $(this).data('modification-code');
    $(".custom-modal-form #data-modification-id").val( modificationId );
    $(".custom-modal-form #data-modification-name").val( modificationName );
    $(".custom-modal-form #data-modification-code").val( modificationCode );
})

const btnUp = {
    el: document.querySelector('.btn-up'),
    show() {
        // удалим у кнопки класс btn-up_hide
        this.el.classList.remove('btn-up_hide');
    },
    hide() {
        // добавим к кнопке класс btn-up_hide
        this.el.classList.add('btn-up_hide');
    },
    addEventListener() {
        // при прокрутке содержимого страницы
        window.addEventListener('scroll', () => {
            // определяем величину прокрутки
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            // если страница прокручена больше чем на 400px, то делаем кнопку видимой, иначе скрываем
            scrollY > 400 ? this.show() : this.hide();
        });
        // при нажатии на кнопку .btn-up
        document.querySelector('.btn-up').onclick = () => {
            // переместим в начало страницы
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }
}

btnUp.addEventListener();
